import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5ea0840"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "scroll-arrow-chevron scroll-arrow-chevron-up" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "scroll-arrow-chevron scroll-arrow-chevron-down" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["scroll-arrow scroll-arrow-up", { visible: _ctx.showUpHint }]),
      style: _normalizeStyle({ top: _ctx.upArrowTop + 'px' }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollUp && _ctx.scrollUp(...args))),
      "aria-hidden": "true"
    }, _hoisted_2, 6),
    _createElementVNode("div", {
      class: _normalizeClass(["scroll-arrow scroll-arrow-down", { visible: _ctx.showDownHint }]),
      style: _normalizeStyle({ bottom: _ctx.downArrowBottom + 'px' }),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollDown && _ctx.scrollDown(...args))),
      "aria-hidden": "true"
    }, _hoisted_4, 6)
  ], 64))
}